export const SET_WORKSTATIONS = 'SET_WORKSTATIONS';
export const SET_ZONES = 'SET_ZONES';
export const SET_ACTIVEWORKSTATIONS = 'SET_ACTIVEWORKSTATIONS';
export const SET_ACTIVERECYCLINGWORKSTATIONS = 'SET_ACTIVERECYCLINGWORKSTATIONS';
export const SET_SELECTEDWORKSTATION = 'SET_SELECTEDWORKSTATION';
export const SET_SELECTEDZONE = 'SET_SELECTEDZONE';
export const SET_NOSELECTEDWORKSTATION = 'SET_NOSELECTEDWORKSTATION';
export const SET_MACHINEPARAMETERS = 'SET_MACHINEPARAMETERS';
export const SET_WORKSTATIONNOTIFICATIONSDRAWEROPEN = 'SET_WORKSTATIONNOTIFICATIONSDRAWEROPEN';
export const SET_OPERATORS = 'SET_OPERATORS';
export const SET_CARPENTRYWORKSTATION = 'SET_CARPENTRYWORKSTATION';
export const SET_NOSELECTEDRECYCLINGWORKSTATION = 'SET_NOSELECTEDRECYCLINGWORKSTATION';
export const SET_SELECTEDRECYCLINGWORKSTATION = 'SET_SELECTEDRECYCLINGWORKSTATION';

